module.exports = __webpack_public_path__ + "static/media/homepage-mobile.6875aff5.svg";